<!-- 注册 -->
<template>
  <div class="login-wrap">
    <div class="container main-1">
      <h2>免费注册 <span>如果您已拥有一富财经账号，可<nuxt-link to="/login" class="yf-login-text">点此登录</nuxt-link></span></h2>
      <section class="form">
        <div class="form-item clearfix">
          <label for="phoneNumber" class="left">手机号：</label>
          <input
            class="login-input left"
            :class="{ success: phoneNumber__state === 'success', error: phoneNumber__state === 'error' }"
            type="text"
            v-model="phoneNumber"
            autofocus
            tabindex="1"
            @focus="phoneNumber__state = 'normal'"
            @blur="checkPhoneNumber">
          <div class="login-tip left">
            <p class="placeholder" v-if="phoneNumber__state === 'normal'">注册成功后即可使用手机号码登录</p>
            <p class="error yf-text_red" v-else-if="phoneNumber__state === 'error'">
              <i class="iconfont icon-cuowu"></i> {{ phoneNumber__state_Msg }}
            </p>
            <p class="success" v-else-if="phoneNumber__state === 'success'">
              <i class="iconfont icon-zq"></i>
            </p>
          </div>
        </div>
        <div class="form-item clearfix">
          <label for="userName" class="left">昵&nbsp;&nbsp;&nbsp;称：</label>
          <input
            class="login-input left"
            :class="{ success: userName__state === 'success', error: userName__state === 'error' }"
            type="text"
            v-model.trim="userName"
            tabindex="2"
            maxlength="12"
            @focus="userName__state = 'normal'"
            @blur="checkUserName">
          <div class="login-tip left">
            <p class="placeholder" v-if="userName__state === 'normal'">请输入至少三个汉字或至少6个字符的昵称</p>
            <p class="error yf-text_red" v-else-if="userName__state === 'error'">
              <i class="iconfont icon-cuowu"></i> {{ userName__state_Msg }}
            </p>
            <p class="success" v-else-if="userName__state === 'success'">
              <i class="iconfont icon-zq"></i>
            </p>
          </div>
        </div>
        <div class="form-item clearfix">
          <label for="password" class="left">密&nbsp;&nbsp;&nbsp;码：</label>
          <input
            class="login-input left"
            :class="{ success: passWord__state === 'success', error: passWord__state === 'error' }"
            type="password"
            v-model="passWord"
            tabindex="3"
            maxlength="16"
            @focus="passWord__state = 'normal'"
            @blur="checkPassWord">
          <div class="login-tip left">
            <p class="placeholder" v-if="passWord__state === 'normal'">6-16位，英文（区分大小写）、数字或常用符号</p>
            <p class="error yf-text_red" v-else-if="passWord__state === 'error'">
              <i class="iconfont icon-cuowu"></i> {{ passWord__state_Msg }}
            </p>
            <p class="success" v-else-if="passWord__state === 'success'">
              <i class="iconfont icon-zq"></i>
            </p>
          </div>
        </div>
        <div class="form-item clearfix">
          <label for="vercode" class="left">验证码：</label>
          <input
            class="login-input left"
            :class="{ success: verCode__state === 'success', error: verCode__state === 'error' }"
            type="text"
            style="width: 200px;"
            v-model="verCode"
            tabindex="4"
            maxlength="6"
            @focus="verCode__state = 'normal'"
            @blur="checkVerCode">
          <button type="button" class="left msg-code" tabindex="6" v-if="!verCode1.length" @click="getVerCode">获取验证码</button>
          <button type="button" class="left verify-code" tabindex="6" v-else @click="getVerCode">{{ verCode1 }}</button>
          <div class="login-tip left">
            <p class="placeholder" v-if="verCode__state === 'normal'">点击可获取验证码</p>
            <p class="error yf-text_red" v-else-if="verCode__state === 'error'">
              <i class="iconfont icon-cuowu"></i> {{ verCode__state_Msg }}
            </p>
          </div>
        </div>
        <div class="form-item clearfix">
          <label for="msgCode" class="left">短信码：</label>
          <input
            class="login-input left"
            type="password"
            style="width: 200px;"
            v-model="msgCode"
            tabindex="5"
            maxlength="16"
            @keydown.enter="handleSignUp"
            @blur="checkMsgCode">
          <button type="button" class="left msg-code" :class="{ 'send-auth-code': isSendAuthCode }" tabindex="6" @click="getAuthCode">{{ isSendAuthCode ? `${time}s后重新获取` : '获取手机验证码' }}</button>
          <div class="login-tip left">
            <p class="error yf-text_red" v-if="msgCode__state === 'error'">
              <i class="iconfont icon-cuowu"></i> {{ msgCode__state_Msg }}
            </p>
            <p class="success" v-else-if="msgCode__state === 'success'">
              <i class="iconfont icon-zq"></i>
            </p>
          </div>
        </div>
        <div class="form-item clearfix" v-if="teacherName || $route.query.from">
          <label for="msgCode" class="left">邀请人：</label>
          <span style="line-height: 40px">{{ teacherName || '一富财经' }}</span>
        </div>
        <div class="form-item form-item-1 clearfix" style="width: 400px">
          <p class="checkbox-wrap left" @click="isSignPact = !isSignPact" tabindex="7"><input type="checkbox" class="checkbox" v-model="isSignPact"> 我已阅读并同意</p>
          <nuxt-link to="/about?id=19" class="pact yf-login-text left" target="_blank">《一富财经用户协议》</nuxt-link>
          <nuxt-link to="/about?id=18" class="pact yf-login-text left" target="_blank">《一富财经免责声明》</nuxt-link>
          <br>
          <p v-show="pactTip" class="pact-tip error yf-text_red">请同意用户协议！</p>
        </div>
        <div class="form-item form-item-1">
          <button type="button" class="login-btn" tabindex="8" @click="handleSignUp">立即注册</button>
        </div>
      </section>
      <section class="login-ad">
        <img src="~assets/signup-ad.jpg" alt="投资者教育平台">
      </section>
    </div>
  </div>
</template>

<script>
import Dialog from '~/utils/Dialog'
import md5 from '~/utils/md5'

export default {
  name: 'register',
  scrollToTop: true,
  head () {
    return {
      title: '注册-一富财经'
    }
  },
  asyncData ({ store, query, $axios }) {
    if (query.code) {
      return $axios._get('/User/Info', { userId: query.code }).then(res => {
        return {
          teacherName: res.userName || null
        }
      })
    }
  },
  data () {
    return {
      phoneNumber: '',
      phoneNumber__state: 'normal',
      phoneNumber__state_Msg: '',
  
      userName: '',
      userName__state: 'normal',
      userName__state_Msg: '',
  
      passWord: '',
      passWord__state: 'normal',
      passWord__state_Msg: '',

      verCode: '',
      verCode1: '',
      verCode__state: 'normal',
      verCode__state_Msg: '',

      msgCode: '',
      msgCode__state: 'normal',
      msgCode__state_Msg: '',
      isSendAuthCode: false,
      time: 59,
  
      isSignPact: true,
      pactTip: false,

      teacherName: null
    }
  },
  methods: {
    getVerCode () {
      this.$axios._get('/Common/VerificationCode').then(res => {
        this.verCode1 = res
      })
    },
    checkPhoneNumber () {
      let isNull = Boolean(this.phoneNumber === '')
      let isPhoneNumber = /^1[3456789]\d{9}$/.test(this.phoneNumber)
      if (isNull || !isPhoneNumber) {
        this.phoneNumber__state = 'error'
        if (isNull) {
          this.phoneNumber__state_Msg = '请输入手机号！'
        } else if (!isPhoneNumber) {
          this.phoneNumber__state_Msg = '手机号格式不正确！'
        }
        return false
      } else {
        return this.$axios._get('/Auth/Verify', { type: 'phone', value: this.phoneNumber }).then(res => {
          if (res.used === '1') {
            this.phoneNumber__state = 'error'
            this.phoneNumber__state_Msg = '手机号已被注册'
            return false
          } else {
            this.phoneNumber__state = 'success'
            return true
          }
        })
      }
    },
    checkUserName () {
      let isNull = !!(this.userName === '')
      let len = 0
      if (!isNull) {
        for (let i = 0; i < this.userName.length; i++) {
          if (/[\u4e00-\u9fa5]/.test(this.userName[i])) {
            len += 2
          } else {
            len++
          }
        }
      }
      if (isNull || len < 6) {
        this.userName__state = 'error'
        if (isNull) {
          this.userName__state_Msg = '请输入昵称！'
        } else if (len < 6) {
          this.userName__state_Msg = '长度至少为6个字符以上'
        }
        return false
      } else {
        return this.$axios._get('/Auth/Verify', { type: 'username', value: this.userName }).then(res => {
          if (res.used === '1') {
            this.userName__state = 'error'
            this.userName__state_Msg = '昵称已被注册'
            return false
          } else {
            this.userName__state = 'success'
            return true
          }
        })
      }
    },
    checkPassWord () {
      let pw = this.passWord
      let isNull = Boolean(pw === '')
      let l = pw.length
      if (isNull || l < 6) {
        this.passWord__state = 'error'
        if (isNull) {
          this.passWord__state_Msg = '请输入密码！'
        } else if (l < 6) {
          this.passWord__state_Msg = '密码长度至少六位数'
        }
        return false
      } else {
        this.passWord__state = 'success'
        return true
      }
    },
    checkVerCode () {
      if (!this.verCode1.length) {
        this.verCode__state = 'error'
        this.verCode__state_Msg = '请获取验证码！'
        return false
      } else if (!this.verCode.length) {
        this.verCode__state = 'error'
        this.verCode__state_Msg = '请输入验证码！'
        return false
      } else {
        this.verCode__state = 'normal'
        this.verCode__state_Msg = ''
        return true
      }
    },
    checkMsgCode () {
      if (this.msgCode === '') {
        this.msgCode__state_Msg = '请输入短信验证码'
        return false
      } else {
        this.msgCode__state = 'success'
        return true
      }
    },
    getAuthCode (e) {
      if (this.checkVerCode()) {
        let isCan = this.checkPhoneNumber()
        if (typeof isCan.then === 'function') {
          isCan.then(res => {
            if (res) {
              e.target.disabled = true
              let verCode = 'sgvm-' + this.verCode
              this.$axios._post('/Common/SmsCode', {
                phone: this.phoneNumber,
                verCode: md5('sgvm-' + this.verCode).toUpperCase()
              }).then(() => {
                this.isSendAuthCode = true
                var t = setInterval(() => {
                  this.time -= 1
                  if (this.time === 0) {
                    clearInterval(t)
                    this.isSendAuthCode = e.target.disabled = false
                  }
                }, 1000)
              }).catch(() => {
                e.target.disabled = false
              })
            }
          })
        }
      }
    },
    async handleSignUp (e) {
      let isCan = await this.checkPhoneNumber()
      let isCan1 = await this.checkUserName()

      let com = () => {
        if (isCan && isCan1 && this.checkPassWord() && this.checkMsgCode()) {
          if (!this.isSignPact) {
            this.pactTip = true
            setTimeout(() => {
              this.pactTip = false
            }, 3000)
            return
          } else {
            e.target.disabled = true
            this.$axios._post('/Auth/Register', {
              phone: this.phoneNumber,
              username: this.userName,
              password: this.passWord,
              code: this.msgCode,
              invite: this.$route.query.code || undefined,
              from: this.$route.query.from || undefined  
            }).then(res => {
              e.target.disabled = false
              this.$cookies.set('yf_jwt', res.token)
              Dialog.alert('恭喜注册成功！', {
                type: 'success',
                showCancelButton: true,
                confirmButtonText: '前往首页'
              }).then(() => {
                window.location.href = location.origin
              }).catch(() => {
                window.location.reload()
              })
            }).catch(err => {
              console.log(err)
              e.target.disabled = false
            })
          }
        }
      }
      await com()
    }
  }
}
</script>
